import { Component, OnInit } from '@angular/core';
import { faHeartbeat, faRunning } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';

@Component({
  selector: 'vex-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  icon = {
    "faHeartbeat": faHeartbeat,
    "faRunning": faRunning
  };

  constructor(public guiService: GuiService, public translate: TranslateService) { }

  ngOnInit(): void {
    setTimeout(()=>this.guiService.showSpinner = false,0)
  }

}
